module.exports = __webpack_public_path__ + "static/media/amazonmusic_icon.f1c20642.png";